<template>
  <div>
    <div class="stat-item" :style="itemStyle">
      {{ formattedValue }}
    </div>
    <slot></slot>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  props: {
    value: {
      type: Number,
      required: true,
    },
    color: {
      type: String,
      default: () => '#0000000',
    },
    accent: {
      type: Boolean,
      default: () => false,
    },
    percent: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    itemStyle() {
      return {
        color: this.color,
        border: `2px solid ${this.accent ? '#727171' : '#e2e2e2'}`,
        fontWeight: this.accent ? 'bold' : 'normal',
      };
    },
    formattedValue() {
      return this.percent
        ? `${this.value >= 0 ? '+' : ''}${this.value}%`
        : this.value.toLocaleString('en-US');
    },
  },
});
</script>

<style lang="scss" scoped>
.stat-item {
  display: inline-block;
  width: 75px;
  text-align: center;
  padding: 5px 10px;
  border-radius: 5px;
  margin: 10px 10px 0;
}
</style>
